export default "__VITE_ASSET__B7Oyf4IK__"